import { ref, Ref } from 'vue'
import { v4 } from 'uuid'
import type { InventoryPickerItem, InventoryPickerGroup } from './types'

export function useJobInventoryGroupPicker(
  modelValue: Ref<InventoryPickerGroup>,
  emit: (event: 'update:modelValue', value: InventoryPickerGroup) => void,
) {
  const inventoryItemPickerRefs = ref<any[]>([])
  // Get disabled inventory sub types for a specific item (exclude already selected ones)
  const getDisabledInventorySubTypes = (currentIndex: number): number[] => {
    return modelValue.value.inventory
      .filter((item, index) => index !== currentIndex && item.inventorySubTypeId !== null)
      .map((item) => item.inventorySubTypeId!)
  }

  const addInventoryItem = () => {
    const emptyItemIndex = modelValue.value.inventory.findIndex(
      (item) => item.inventorySubTypeId === null,
    )

    if (emptyItemIndex === -1) {
      const newItems: InventoryPickerItem[] = [
        ...modelValue.value.inventory,
        {
          inventorySubTypeId: null,
          quantity: null,
          _uniqueId: v4(),
          id: null,
          autofocus: true,
        },
      ]
      const updatedGroup: InventoryPickerGroup = {
        ...modelValue.value,
        inventory: newItems,
      }
      emit('update:modelValue', updatedGroup)
    } else {
      if (inventoryItemPickerRefs.value.length > emptyItemIndex) {
        inventoryItemPickerRefs.value[emptyItemIndex].focus()
      }
    }
  }

  const removeInventoryItem = (index: number) => {
    const newItems = modelValue.value.inventory.filter((_, i) => i !== index)
    const updatedGroup: InventoryPickerGroup = {
      ...modelValue.value,
      inventory: newItems,
    }
    emit('update:modelValue', updatedGroup)
  }

  const updateInventoryItem = (index: number, updatedItem: InventoryPickerItem) => {
    const newItems = [...modelValue.value.inventory]
    newItems[index] = updatedItem
    const updatedGroup: InventoryPickerGroup = {
      ...modelValue.value,
      inventory: newItems,
    }
    emit('update:modelValue', updatedGroup)
  }

  return {
    getDisabledInventorySubTypes,
    addInventoryItem,
    removeInventoryItem,
    updateInventoryItem,
    inventoryItemPickerRefs,
  }
}
